import { JsonConverter } from 'app/JsonConverter'

export class Decision implements JsonConverter {
  
  private _texto: string
  private _cobertura: string
  private _tipo: Tipo

  constructor(texto: string, cobertura: string, tipo: Tipo) {
    this._cobertura = cobertura
    this._texto = texto
    this._tipo = tipo
  }  

  get texto(): string {
    return this._texto
  }

  get cobertura(): string {
    return this._cobertura
  }

  get tipo(): Tipo {
    return this._tipo
  }
  
  toJson() {
    return {
      texto: this.texto,
      cobertura: this.cobertura,
      tipo: this.tipo
    }
  }
}

export class Tipo implements JsonConverter {
  
  private _tipo: string
  private _parametros: Object

  constructor(tipo: string, parametros: Object) {
    this._parametros = parametros
    this._tipo = tipo
  }

  get tipo(): string {
    return this._tipo
  }

  get parametros(): Object {
    return this._parametros
  }

  set parametros(parametros) {
    this._parametros = parametros
  }

  toJson() {
    return {
      tipo: this.tipo,
      parametros: this._parametros
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/dominio/decision.ts